import { ReactNode, type FC } from "react";
import { type IconType } from "react-icons";
import { HStack, IconButton, Text, type TextProps } from "@chakra-ui/react";

import { LeadingIcon } from "../../leading-icon";
import { SidebarDrawerOpener } from "@widgets/sidebar";

interface Props {
  icon: IconType;
  title: string;
  actions: ReactNode;
  helperText?: string;
  textProps?: Partial<TextProps>;
}

export const SectionHeaderMobile: FC<Props> = ({
  icon: Icon,
  title,
  actions,
  helperText,
  textProps,
}) => {
  return (
    <HStack
      p={2}
      w="full"
      justifyContent="space-between"
      display={{ base: "flex", md: "none" }}
    >
      <HStack w="full" alignItems="center" justifyContent="space-between">
        <IconButton variant="plain" alignSelf="flex-start">
          <SidebarDrawerOpener size="md" variant="plain" />
        </IconButton>
        <HStack gap={3} w="full" justifyContent="flex-start">
          <LeadingIcon icon={Icon} containerProps={{ bg: "transparent" }} />
          <Text
            fontWeight="bold"
            fontSize={{ base: "md", md: "2xl" }}
            {...textProps}
          >
            {title}
          </Text>
          <Text color="gray.500" mx={2} fontSize="md">
            {helperText}
          </Text>
        </HStack>
        {actions}
      </HStack>
    </HStack>
  );
};
